import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

import ViewDetails from "./ViewDetails";

import { formatDate, formatTime } from "@/formatting/datetime";
import { formatSecondaryAddress } from "@/formatting/location";
import { type EventOverview } from "@/schemas/events/EventOverview";
import { themes } from "@/Components/Styling/themeConfigs";
import CoverImage from "@/Components/Media/Event/Images/CoverImage";
import ImageCarousel from "@/Components/Media/Event/Images/EventImageCaoursel";

type EventCardProps = {
  event: EventOverview;
  onPress: (eventId: string) => void;
};

export const EventCard: React.FC<EventCardProps> = ({ event, onPress }) => {
  const currentTheme = themes.morning;

  const iconSize = currentTheme.icon.size.web.medium;
  const iconColor = currentTheme.icon.color;

  const styles = StyleSheet.create({
    card: {
      flex: 1,
      // borderRadius: 20,
      // marginBottom: 20,
      // marginHorizontal: 10,
      // overflow: "hidden",
    },
    content: {
      padding: 16,
    },
    title: {
      fontSize: currentTheme.typography.h1.size.web,
      color: currentTheme.typography.h1.color,
      fontWeight: "bold",
      marginBottom: 12,
    },
    infoContainer: {
      gap: 8,
    },
    dateContainer: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
    },
    timeContainer: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
    },
    text: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
    description: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
      marginTop: 16,
      lineHeight: 24,
    },
  });

  return (
    <View style={styles.card}>
      <CoverImage event={event} />
      {event.gallery.images.length > 0 && <ImageCarousel event={event} />}
      {/* Content Section */}
      <View style={styles.content}>
        <Text style={styles.title}>{event.title}</Text>
        <View style={styles.infoContainer}>
          <View style={styles.dateContainer}>
            <MaterialIcons
              name="calendar-today"
              size={iconSize}
              color={iconColor}
            />
            <Text style={styles.text}>
              {formatDate(event.startDateTime, event.timeZone)}
            </Text>
          </View>
          <View style={styles.timeContainer}>
            <MaterialIcons
              name="access-time"
              size={iconSize}
              color={iconColor}
            />
            <Text style={styles.text}>
              {formatTime(event.startDateTime, event.timeZone)} -{" "}
              {formatTime(event.endDateTime, event.timeZone)}
            </Text>
          </View>
          <View style={styles.timeContainer}>
            <MaterialIcons
              name="location-on"
              size={iconSize}
              color={iconColor}
            />
            <Text style={styles.text}>
              {formatSecondaryAddress(event.location.address)}
            </Text>
          </View>
        </View>
        {event.description && (
          <Text style={styles.description}>{event.description}</Text>
        )}
        <ViewDetails event={event} onPress={onPress} />
      </View>
    </View>
  );
};
